module.exports = __webpack_public_path__ + "assets/icons/event-b3ff.svg";